import {User} from '../modules/user/IUsers'

export const USER: User = JSON.parse(localStorage.getItem('user') || '{}')

export const RequestTypes = {
  Sentry : 3,
  Scheduled : 2,
  Emergency : 1,
}

export const brigadeTypes = [
  {
    key: 1,
    value: 'Реанимационная'
  },
  {
    key: 2,
    value: 'Фельдшерская'
  },
  {
    key: 3,
    value: 'Линейная'
  },
  {
    key: 4,
    value: 'Педиатрическая'
  }
]
export const brigadeTypesForDp = [
  {
    key: 1,
    value: 'Реанимационная'
  },
  {
    key: 2,
    value: 'Фельдшерская'
  },
  {
    key: 3,
    value: 'Врачебная'
  },
  {
    key: 4,
    value: 'Педиатрическая'
  }
]

export const brigadeHours = [
  {
    key: "0",
    value: "0"
  },
  {
    key: 1,
    value: 1
  },
  {
    key: 2,
    value: 2
  },
  {
    key: 3,
    value: 3
  },
  {
    key: 4,
    value: 4
  },
  {
    key: 5,
    value: 5
  },
  {
    key: 6,
    value: 6
  },
  {
    key: 7,
    value: 7
  },
  {
    key: 8,
    value: 8
  },
  {
    key: 9,
    value: 9
  },
  {
    key: 10,
    value: 10
  },
  {
    key: 11,
    value: 11
  },
  {
    key: 12,
    value: 12
  },
  {
    key: 13,
    value: 13
  },
  {
    key: 14,
    value: 14
  },
  {
    key: 15,
    value: 15
  },
  {
    key: 16,
    value: 16
  },
  {
    key: 17,
    value: 17
  },
  {
    key: 18,
    value: 18
  },
  {
    key: 19,
    value: 19
  },
  {
    key: 20,
    value: 20
  },
  {
    key: 21,
    value: 21
  },
  {
    key: 22,
    value: 22
  },
  {
    key: 23,
    value: 23
  },
]

export const brigadeMinutes = [
  {
    key: "0",
    value: "0"
  },
  {
    key: 15,
    value: 15
  },
  {
    key: 30,
    value: 30
  },
  {
    key: 45,
    value: 45
  },
]
export const SeverityConditionTypes = [
  {
    key: 1,
    value: 'Лёгкое'
  },
  {
    key: 2,
    value: 'Средней тяжести'
  },
  {
    key: 3,
    value: 'Тяжёлое в сознании'
  },
  {
    key: 4,
    value: 'Тяжёлое на кислороде'
  },
  {
    key: 5,
    value: 'Тяжёлое ИВЛ/СИПАП'
  }
]
export const RequestReasonTypes = [

  {
    key: 1,
    value: 'Домой'
  },
  {
    key: 2,
    value: 'В стационар госпитализация'
  },
  {
    key: 3,
    value: 'Роддом'
  },
  {
    key: 4,
    value: 'Аэропорт-Вокзал'
  },
  {
    key: 5,
    value: 'Тяжёлое ИВЛ/СИПАП'
  },
{
    key: 6,
    value: 'Обследование'
  },
{
    key: 7,
    value: 'Из стационара в стационар'
  },
]

export const SENTRYEVENTS = [
  {
    value: "Спортивное мероприятие",
    key: 1,
  },
  {
    value: "Культурно - массовое мероприятие",
    key: 2,
  },
  {
    value: "Массовое мероприятие на открытом воздухе",
    key: 3,
  },
  {
    value: "Дежурство на стройке и объекте с повышенной опасностью",
    key: 4,
  },
  {
    value: "Другое",
    key: 5,
  },

]

export const diagnoses = [
  {
    key: 1,
    value: 'COVID'
  },
  {
    key: 2,
    value: 'Инфаркт'
  },
  {
    key: 3,
    value: 'Инсульт'
  },
  {
    key: 4,
    value: 'Хороший был человек'
  }
]

export const REQUEST_STATUSES = {
  pending: 1,
  inProcess: 2,
  selected: 3,
  closed: 4,
  canceled: 5,
  deleted: 6
}

export const ER_CALL_STATUSES = {
  onApproval: 1,
  onRoute: 2,
  onRouteDelay: 3,
  arrived: 4,
  endedLeftInPlace: 5,
  endedRefusedHospital: 6,
  hospitalizationRequest: 7,
  bookingRequestSent: 8,
  bookingApproved: 9,
  onRouteToHospital: 10,
  stationing: 11,
  ended: 12,
  erReplacementRequired: 13,
  endedTransferred: 14,
  closed: 15,
  bookingOfferReceived: 16,
  closedWithPayment: 17,
  closedWOPayment: 18,
  transferInProcess: 19,
  transferOnRoute: 20,
  transferArrived: 21,
  onRouteToHospitalDelay: 22,
  sentryStart: 23,
  waitingSentryStart: 24,
  waitingTransportStart: 25,
  hospitalizationPending: 26,
  needHospitalizationApprove: 27,
}

export const STATUS_LIST = [
  {
    key: ER_CALL_STATUSES.onRoute,
    value: 'В пути',
  },
  {
    key: ER_CALL_STATUSES.arrived,
    value: 'Прибыл',
  },
  {
    key: ER_CALL_STATUSES.endedLeftInPlace,
    value: 'Вызов завершен: На месте',
  },
  {
    key: ER_CALL_STATUSES.endedRefusedHospital,
    value: 'Вызов завершен: Oтказ',
  },
  {
    key: ER_CALL_STATUSES.hospitalizationRequest,
    value: 'Запрос госпитализации',
  },
  {
    key: ER_CALL_STATUSES.onRouteToHospital,
    value: 'На пути в больницу',
  },
  {
    key: ER_CALL_STATUSES.stationing,
    value: 'Стационирование',
  },
  {
    key: ER_CALL_STATUSES.ended,
    value: 'Вызов завершен: Госпитализация',
  }
]

export const USER_ROLES = [
  {
    key: 2,
    value: 'Администратор'
  }, {
    key: 3,
    value: 'Диспетчер'
  }
]
export const CENTER_ROLE = [
 {
    key: 5,
    value: 'Центральный Администратор'
  }
]

export const TIME_LIMIT = {
  sentryPending: 300000,
  waitingContractBegin: 60000,
  contractPending: 600000,
  contractAccepted: 300000,
  pending: 180000,
  inProcess: 60000,
  sentryInProcess: 180000,
  sentryWaitingApproval: 180000,
  waitingApproval: 30000,
  approved: 60000,
  arrived: 1800000,
  hospitalizationRequest: 900000,
  sentryHospitalizationRequest: 1800000,
  bookingApproved: 60000,
  bookingRejected: 30000,
  stationing: 1800000,
  onRouteToHospital: 1800000,
  erReplacementRequired: 60000,
}

export const APPLICATIONS_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Новые',
    value: 1
  },
  {
    text: 'С предложениями',
    value: 2
  },
  {
    text: 'Ожидает подтверждения',
    value: 3
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const APPLICATIONS_FILTER_DC = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Новые',
    value: 1
  },
  {
    text: 'С предложениями',
    value: 2
  },
  {
    text: 'Ожидает подтверждения',
    value: 3
  },
  {
    text: 'Ожидает оплаты',
    value: 4
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const INSURANCE_ER_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Подтверждено',
    value: 1
  },
  {
    text: 'В пути',
    value: 2
  },
  {
    text: 'Прибыл',
    value: 4
  },
  {
    text: 'Требуется замена СМП',
    value: 13
  },
  {
    text: 'Замена в пути',
    value: 14
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const INSURANCE_ER_FILTER_DC = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Ожидает выезда',
    value: 1
  },
  {
    text: 'В пути ',
    value: 2
  },
  {
    text: 'Задержка выезда',
    value: 3
  },
  {
    text: 'Прибыл',
    value: 4
  },
  {
    text: 'Дежурство',
    value: 50
  },
  {
    text: 'Экстренный',
    value: 51
  },
  {
    text: 'Транспортировка',
    value: 52
  },
  // {
  //   text: 'Подтверждено',
  //   value: 1
  // },

  {
    text: 'Продление ',
    value: 100
  },
  {
    text: 'Не оплачено',
    value: 15
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const HOSPITALIZATION_FILTER_DC = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Запрос госпитализации',
    value: 7
  },
  {
    text: 'Бронирование отклонено',
    value: 8
  },
  {
    text: 'Бронирование подтверждено',
    value: 9
  },
  {
    text: 'На пути в больницу',
    value: 10
  },
  {
    text: 'Стацианирование',
    value: 11
  },
  {
    text: 'Требуется замена СМП',
    value: 13
  },
  {
    text: 'Не оплачено',
    value: 44
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const ER_BIDDING_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Новые',
    value: 1
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const HOSPITALIZATION_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Запрос госпитализации',
    value: 7
  },
  {
    text: 'Бронирование отклонено',
    value: 8
  },
  {
    text: 'Бронирование подтверждено',
    value: 9
  },
  {
    text: 'На пути в больницу',
    value: 10
  },
  {
    text: 'Стацианирование',
    value: 11
  },
  {
    text: 'Требуется замена СМП',
    value: 13
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const EMERGENCY_APP_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Отправленные предложения',
    value: 2
  },
  {
    text: 'Ожидает подверждения',
    value: 3
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const EMERGENCY_ER_FILTER = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Подтверждено',
    value: 1
  },
  {
    text: 'В пути',
    value: 2
  },
  {
    text: 'В пути(Задержка)',
    value: 3
  },
  {
    text: 'Прибыл',
    value: 4
  },
  {
    text: 'Запрос госпитализации',
    value: 7
  },
  {
    text: 'Бронирование подтверждено',
    value: 9
  },
  {
    text: 'На пути в больницу',
    value: 10
  },
  {
    text: 'Стацианирование',
    value: 11
  },
  {
    text: 'Требуется замена СМП',
    value: 13
  },
  {
    text: 'Проблематичные',
    value: true
  }
]


export const EMERGENCY_ER_FILTER_DP = [
  {
    text: 'Все',
    value: 0
  },
  {
    text: 'Ожидает выезда',
    value: 1
  },
  {
    text: 'В пути',
    value: 2
  },
  {
    text: 'В пути(Задержка)',
    value: 3
  },
  {
    text: 'Прибыл',
    value: 4
  },
  {
    text: 'Запрос госпитализации',
    value: 7
  },
  {
    text: 'Бронирование подтверждено',
    value: 9
  },
  {
    text: 'На пути в больницу',
    value: 10
  },
  {
    text: 'Стацианирование',
    value: 11
  },
  {
    text: 'Требуется замена СМП',
    value: 13
  },
  {
    text: 'Дежурство',
    value: 50
  },
  {
    text: 'Экстренный',
    value: 51
  },
  {
    text: 'Транспортировка',
    value: 52
  },
  {
    text: 'Проблематичные',
    value: true
  }
]

export const NOTIFICATIONS_FILTER = [
  {
    text: 'Все',
    type: 'all'
  },
  {
    text: 'Непрочитанные',
    type: 'unread'
  },
  {
    text: 'Прочитанные',
    type: 'read'
  }
]

export const GENDER = [{key: 1, type: 'М'}, {key: 2, type: 'Ж'}]

export const SEARCH_HEAD = ['Номер', 'Адрес', 'Повод обращения', 'Возраст', 'Дата', 'Имя пациента', 'Статус']
export const SEARCH_HEAD_DC_DP = ['Номер', 'Адрес', 'Повод обращения', 'Дата', 'Имя пациента', 'Статус']

export const DISPATCHERS_TABLE_HEAD = ['ФИО', 'Дата', 'Телефон', 'Доп. Телефон', 'Моб. Телефон', 'Почта', '']

export const ACTIVE_TICKETS_STATUS_NAMES = [
  'Подтверждено',
  'В пути',
  'В пути (задержка)',
  'Прибыл',
  'Вызов завершен: Оставлен на месте',
  'Вызов завершен: Отказ от госпитализации',
  'Запрос госпитализации',
  'Запрос бронирования',
  'Бронирование подтверждено',
  'На пути в больницу',
  'Стационирование',
  'Вызов завершен',
  'Требуется замена СМП',
  'Вызов завершен: Передана другой СМП',
  'Вызов отменен',
  'Предложение о бронировании',
  'Вызов отменен, оплатить',
  'Вызов отменен, без оплаты',
  'Замена в процессе',
  'Замена в пути',
  'Замена прибыла'
]

export const REGIONS = [
  {key: 2, type: 'Москва'},
  {key: 2, type: 'За МКАД'},
  {key: 3, type: 'Санкт Петербург'},
  {key: 3, type: 'За КАД'},
]

export const CUSTOMERSREGIONS = [
  {key: 1, type: 'Москва'},
  {key: 2, type: 'Санкт Петербург'},
]

export const PAYMENT_TYPES = [
  {key: 1, type: 'ОМС'},
  {key: 2, type: 'ДМС'}
]

export const ROOM_TYPES = [
  {key: 1, type: 'ВИП'},
  {key: 2, type: 'Одноместная'},
  {key: 3, type: 'Двухместная'},
  {key: 4, type: 'Общая'}
]

export const DEPARTMENTS = [
  {key: 1, type: 'акушерское дело'},
  {key: 2, type: 'акушерство и гинекология'},
  {key: 3, type: 'аллергология и иммунология'},
  {key: 4, type: 'анестезиология и реаниматология'},
  {key: 5, type: 'гастроэнтерология'},
  {key: 6, type: 'гематология'},
  {key: 7, type: 'гериатрия'},
  {key: 8, type: 'дерматовенерология'},
  {key: 9, type: 'детская кардиология'},
  {key: 10, type: 'детская онкология'},
  {key: 11, type: 'детская урология-андрология'},
  {key: 12, type: 'детская хирургия'},
  {key: 13, type: 'детская эндокринология'},
  {key: 14, type: 'инфекционные болезни'},
  {key: 15, type: 'кардиология'},
  {key: 16, type: 'колопроктология'},
  {key: 17, type: 'медицинская реабилитация'},
  {key: 18, type: 'неврология'},
  {key: 19, type: 'нейрохирургия'},
  {key: 20, type: 'неонатология'},
  {key: 21, type: 'нефрология'},
  {key: 22, type: 'онкология'},
  {key: 23, type: 'оториноларингология'},
  {key: 24, type: 'офтальмология'},
  {key: 25, type: 'паллиативная медицинская помощь'},
  {key: 26, type: 'педиатрия'},
  {key: 27, type: 'пластическая хирургия'},
  {key: 28, type: 'профпатология'},
  {key: 29, type: 'психиатрия'},
  {key: 30, type: 'психиатрия-наркология'},
  {key: 31, type: 'пульмонология'},
  {key: 32, type: 'радиология, радиотерапия'},
  {key: 33, type: 'ревматология'},
  {key: 34, type: 'сердечно-сосудистая хирургия'},
  {key: 35, type: 'скорая медицинская помощь'},
  {key: 36, type: 'стоматология детская'},
  {key: 37, type: 'терапия'},
  {key: 38, type: 'токсикология'},
  {key: 39, type: 'торакальная хирургия'},
  {key: 40, type: 'травматология и ортопедия'},
  {key: 41, type: 'трансплантация костного мозга и гемопоэтических стволовых клеток'},
  {key: 42, type: 'урология'},
  {key: 43, type: 'фтизиатрия'},
  {key: 44, type: 'хирургия'},
  {key: 45, type: 'хирургия (абдоминальная)'},
  {key: 46, type: 'хирургия (комбустиология)'},
  {key: 47, type: 'хирургия (трансплантация органов и (или) тканей)'},
  {key: 48, type: 'челюстно-лицевая хирургия'},
  {key: 49, type: 'эндокринология'}
]

export const ROOT_ADMIN_HOSPITAL_REGIONS = [
  {key: 1, type: 'ВАО'},
  {key: 2, type: 'ЗАО'},
  {key: 3, type: 'ЗЕЛ'},
  {key: 4, type: 'МО'},
  {key: 5, type: 'САО'},
  {key: 6, type: 'СВАО'},
  {key: 7, type: 'СВО'},
  {key: 8, type: 'СЗАО'},
  {key: 9, type: 'ЦАО'},
  {key: 10, type: 'ЮАО'},
  {key: 11, type: 'ЮВАО'},
  {key: 12, type: 'ЮЗАО'}
]

export const INSURANCE_PARTNERSHIPS = ['Название', 'Адрес', 'Телефон', 'Почта', 'Приоритет', ' ']

export const EMERGENCY_PARTNERSHIPS = ['Название', 'Адрес', 'Телефон', 'Почта', ' ']

export const PARTNERSHIPS_STATUS_TEXTS = ['Запрос отправлен', 'Партнер', 'Отклонено', 'Приостановлено']

export const PARTNERSHIPS_PRIORITY_TEXTS = [
  {key: 1, type: 'Высокий'},
  {key: 2, type: 'Средний'},
  {key: 3, type: 'Низкий'}
]

export const INSURANCE_CONN_STATUS_MESSAGES = {
  2: '[XXX] приняла Ваше предложение на сотрудничество.',
  3: '[XXX] отклонила Ваше предложение на сотрудничество.',
  5: '[XXX] отменила Ваше сотрудничество.'
}

export const ER_CONN_STATUS_MESSAGES = {
  1: '[XXX] отправила запрос на сотрудничество.',
  2: 'Ваше сотрудничество с [XXX] было возобновлено.',
  3: '[XXX] отменила Ваше сотрудничество.',
  4: 'Ваше сотрудничество с [XXX] было приостановлено.',
  5: '[XXX] отменила Ваше сотрудничество.'
}

export const CITIES = [{key: 1, value: 'Все'}, {key: 2, value: 'Москва'}, {key: 3, value: 'Санкт Петербург'}]

export const CITIES_UPDATE = [{key: 2, value: 'Москва'}, {key: 3, value: 'Санкт Петербург'}]

export const LONG_TERM_TYPES = [{key: 1, value: 'Предоплата'}, {key: 2, value: 'Постоплата'}]

export const CITIES_ABBR = [{id: 2, value: 'МСК'}, {id: 3, value: 'СПБ'}]
